import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { EDashboardItemType, EDashboardTabType, IDashboardItem } from '../types/eecs-dashboard.types';

export interface EecsDashboardInitialState {
  isLoading: boolean;
  dashboard: IDashboardItem;
  currentTab: EDashboardTabType;
  availablePredictionYears: string[];
}

const eecsDashboardInitialState: EecsDashboardInitialState = {
  isLoading: false,
  currentTab: EDashboardTabType.SPOT,
  availablePredictionYears: [],
  dashboard: {
    [EDashboardItemType.SPOT]: {
      title: 'Spot',
      total: null,
      change: null,
      url: '/eecs-go/eecs-inventory',
    },
    [EDashboardItemType.FORWARDS]: {
      title: 'Forwards',
      total: null,
      change: null,
      url: '/eecs-go/eecs-forwards',
    },
    [EDashboardItemType.LISTED_SPOT]: {
      title: 'Listed SPOT',
      total: null,
      change: null,
      url: '/eecs-go/eecs-inventory?hasExchanges=true',
    },
    [EDashboardItemType.LISTED_FORWARD]: {
      title: 'Listed FORWARD',
      total: null,
      change: null,
      url: '/eecs-go/eecs-forwards?hasExchanges=true',
    },
    [EDashboardItemType.REVENUE]: {
      title: 'Revenue',
      total: null,
      change: null,
      url: '/eecs-go/eecs-transactions?transactionType=sell',
    },
    [EDashboardItemType.EXPENSE]: {
      title: 'Expense',
      total: null,
      change: null,
      url: '/eecs-go/eecs-transactions?transactionType=buy',
    },
  },
};

export const eecsDashboard = createSlice({
  name: 'eecsDashboard',
  initialState: eecsDashboardInitialState,
  reducers: {
    setIsLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setDashboard(state, action: PayloadAction<IDashboardItem>) {
      state.dashboard = action.payload;
    },
    setCurrentTab(state, action: PayloadAction<EDashboardTabType>) {
      state.currentTab = action.payload;
    },
    setAvailablePredictionYears(state, action: PayloadAction<string[]>) {
      state.availablePredictionYears = action.payload;
    },
  },
});

export const { setIsLoading, setDashboard, setCurrentTab, setAvailablePredictionYears } = eecsDashboard.actions;
